export const XP_LEVELS = [
  { level: 1, xpRequired: 0 },
  { level: 2, xpRequired: 20 }, // 2 adventures OR 2.5 jobs OR 4 fights
  { level: 3, xpRequired: 60 }, // 6 adventures OR 7.5 jobs OR 12 fights
  { level: 4, xpRequired: 100 }, // 10 adventures OR 12.5 jobs OR 20 fights
  { level: 5, xpRequired: 150 }, // 15 adventures OR 18.75 jobs OR 30 fights
  { level: 6, xpRequired: 250 }, // 25 adventures OR 31.25 jobs OR 50 fights
  { level: 7, xpRequired: 400 }, // 40 adventures OR 50 jobs OR 80 fights
  { level: 8, xpRequired: 600 }, // 60 adventures OR 75 jobs OR 120 fights
  { level: 9, xpRequired: 1000 }, // 100 adventures OR 125 jobs OR 200 fights
  { level: 10, xpRequired: 1500 }, // 150 adventures OR 187.5 jobs OR 300 fights
  { level: 11, xpRequired: 2200 }, // 220 adventures OR 275 jobs OR 440 fights
  { level: 12, xpRequired: 3000 }, // 300 adventures OR 375 jobs OR 600 fights
  { level: 13, xpRequired: 4000 }, // 400 adventures OR 500 jobs OR 800 fights
  { level: 14, xpRequired: 5000 }, // 500 adventures OR 625 jobs OR 1000 fights
  { level: 15, xpRequired: 6000 }, // 600 adventures OR 750 jobs OR 1200 fights
  { level: 16, xpRequired: 7000 }, // 700 adventures OR 875 jobs OR 1400 fights
  { level: 17, xpRequired: 8000 }, // 800 adventures OR 1000 jobs OR 1600 fights
  { level: 18, xpRequired: 9000 }, // 900 adventures OR 1125 jobs OR 1800 fights
  { level: 19, xpRequired: 10000 }, // 1000 adventures OR 1250 jobs OR 2000 fights
  { level: 20, xpRequired: 11000 }, // 1100 adventures OR 1375 jobs OR 2200 fights
  { level: 21, xpRequired: 12000 }, // 1200 adventures OR 1500 jobs OR 2400 fights
  { level: 22, xpRequired: 13000 }, // 1300 adventures OR 1625 jobs OR 2600 fights
  { level: 23, xpRequired: 14000 }, // 1400 adventures OR 1750 jobs OR 2800 fights
  { level: 24, xpRequired: 15000 }, // 1500 adventures OR 1875 jobs OR 3000 fights
  { level: 25, xpRequired: 16000 }, // 1600 adventures OR 2000 jobs OR 3200 fights
  { level: 26, xpRequired: 17000 }, // 1700 adventures OR 2125 jobs OR 3400 fights
  { level: 27, xpRequired: 18000 }, // 1800 adventures OR 2250 jobs OR 3600 fights
  { level: 28, xpRequired: 19000 }, // 1900 adventures OR 2375 jobs OR 3800 fights
  { level: 29, xpRequired: 20000 }, // 2000 adventures OR 2500 jobs OR 4000 fights
  { level: 30, xpRequired: 21000 }, // 2100 adventures OR 2625 jobs OR 4200 fights
];
